import { Avatar, Card, CardContent, Grid, Typography } from '@mui/material';
import { green } from '@mui/material/colors';
import PeopleIcon from '@mui/icons-material/PeopleOutlined';

const TotalCustomers = ({ handleClick, title, quantity, ...props }) => (
  <Card
    {...props}
    sx={{
      transition: '.5s',
      ':hover': {
        transform: 'scale(1.01)',
        borderRadius: '10px',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px'
      }
    }}
  >
    <CardContent>
      <Grid
        container
        spacing={3}
        sx={{ justifyContent: 'space-between', cursor: 'pointer' }}
        onClick={() => {
          handleClick();
        }}
      >
        <Grid item>
          <Typography color="textSecondary" gutterBottom variant="h6">
            {title}
          </Typography>
          <Typography color="textPrimary" variant="h3">
            {quantity}
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            sx={{
              backgroundColor: green[600],
              height: 56,
              width: 56
            }}
          >
            <PeopleIcon />
          </Avatar>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

export default TotalCustomers;
